exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".markerTable[data-v-3c00de3f]  .el-checkbox{margin:0!important}.markerTable .el-table td[data-v-3c00de3f],.markerTable[data-v-3c00de3f]  .el-table th.is-leaf{border:none!important}", ""]);

// exports
